export default __webpack_public_path__ + "static/media/111_background.8f36446c.gif";